var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    _vm.wrapperStyleClasses,
    { interactive: _vm.isInteractive, active: _vm.isActive, borderless: _vm.isBorderless } ],style:({ height: (_vm.size + "px"), width: (_vm.size + "px") }),attrs:{"data-testid":"ci-icon-wrapper"}},[_c('gl-icon',{class:_vm.cssClasses,attrs:{"name":_vm.icon,"size":_vm.size,"aria-label":_vm.status.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }